module.exports = "/app/themes/roboyo2021/dist/img/chat-wht.png?98ebe193a286fea9be2ace466afd2fc9";